import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RecordsFound from "../Images/recordsFound.png";
import MissingData from "../Images/missingData.png";
import DuplicateIcon from "../Images/DuplicateIcon.png";
import "./bulkUploadResult.css";

const BulkLeadsResult = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const dartsFormNeeded = location.state?.dartsFormNeeded;
    const pocName = location.state?.pocName;
    const pocEmail = location.state?.pocEmail;
    const pocNumber = location.state?.pocNumber;
    const numberLogin = location.state?.numberLogin;
    const emailLogin = location.state?.emailLogin;
    const mandatoryTimeDistribution = location.state?.mandatoryTimeDistribution;
    const targetEditDays = location.state?.targetEditDays;
    const inputEditDays = location.state?.inputEditDays;
    const dartsNeeded = location.state?.dartsNeeded;
    const clanNeeded = location.state?.clanNeeded;
    const syncNeeded = location.state?.syncNeeded;
    const roleId = location.state?.roleId;
    const accountId = location.state?.accountId;
    const name = location.state?.name;
    const accountName = location.state?.accountName;

    const handleBackToViewRole = () => {
        const safeRoleId = roleId ?? location.state?.roleId ?? localStorage.getItem("roleId") ?? null;
        const safeAccountId = accountId ?? location.state?.accountId ?? localStorage.getItem("accountId") ?? null;
        const safeAccountName = accountName ?? location.state?.accountName;
        const safeName = name ?? location.state?.name;

        navigate("/user-management", {
            state: {
                roleId: safeRoleId,
                accountId: safeAccountId,
                accountName: safeAccountName,
                name: safeName,
                dartsNeeded: dartsNeeded ?? location.state?.dartsNeeded,
                clanNeeded: clanNeeded ?? location.state?.clanNeeded,
                syncNeeded: syncNeeded ?? location.state?.syncNeeded,
                dartsFormNeeded: dartsFormNeeded ?? location.state?.dartsFormNeeded,
                pocName: pocName ?? location.state?.pocName,
                pocEmail: pocEmail ?? location.state?.pocEmail,
                pocNumber: pocNumber ?? location.state?.pocNumber,
                numberLogin: numberLogin ?? location.state?.numberLogin,
                emailLogin: emailLogin ?? location.state?.emailLogin,
                mandatoryTimeDistribution: mandatoryTimeDistribution ?? location.state?.mandatoryTimeDistribution,
                targetEditDays: targetEditDays ?? location.state?.targetEditDays,
                inputEditDays: inputEditDays ?? location.state?.inputEditDays,
            },
        });
    };

    // ✅ Extract the file name and API response data
    const fileName = location.state?.fileName || "No File Uploaded";
    const bulkUploadResponse = location.state?.data?.bulkUploadUsers || {};
    const apiData = bulkUploadResponse?.data || {};
    const uploadSuccess = bulkUploadResponse?.success ?? false;
    const uploadMessage = bulkUploadResponse?.message || "";

    const successRecords = apiData.number_of_success_records ?? 0;
    const failedRecords = apiData.number_of_failed_records ?? 0;
    const duplicateRecords = apiData.number_of_duplicate_records ?? 0;
    const totalRecords = apiData.number_of_records ?? 0;
    const excelUrl = apiData.excel || null;

    const handleSubmit = () => {
        handleBackToViewRole();
    };

    const handleDownloadErrorSheet = () => {
        if (!excelUrl) return;
        const a = document.createElement("a");
        a.href = excelUrl;
        a.download = "Bulk_Upload_Error_Sheet.xlsx";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <div className="user-management-container">
            <div className="bulk-leads-submit">
                <button className="bulkUploadSubmit" onClick={handleBackToViewRole}>Back</button>
            </div>
            <h2 className="bulk-leads-header">Bulk Leads Result</h2>

            <p style={{ textAlign: "center", fontSize: "14px", marginBottom: "20px" }}>
                <strong>Uploaded File:</strong> {fileName}
            </p>

            {/* Status Message */}
            <div style={{
                textAlign: "center",
                marginBottom: "24px",
                padding: "12px 20px",
                borderRadius: "8px",
                backgroundColor: uploadSuccess ? "#f0fdf4" : "#fef2f2",
                border: uploadSuccess ? "1px solid #bbf7d0" : "1px solid #fecaca",
                color: uploadSuccess ? "#166534" : "#991b1b",
                fontSize: "15px",
                fontFamily: "Inter, sans-serif",
            }}>
                <strong>{uploadSuccess ? "✓ Upload Successful" : "✗ Upload Completed with Issues"}</strong>
                {uploadMessage && <p style={{ margin: "6px 0 0", fontSize: "13px" }}>{uploadMessage}</p>}
                <p style={{ margin: "6px 0 0", fontSize: "13px" }}>
                    Total Records: <strong>{totalRecords}</strong> | 
                    Success: <strong style={{ color: "#166534" }}>{successRecords}</strong> | 
                    Failed: <strong style={{ color: "#991b1b" }}>{failedRecords}</strong> | 
                    Duplicate: <strong style={{ color: "#b45309" }}>{duplicateRecords}</strong>
                </p>
            </div>

            <div className="bulk-leads-cards">
                <div className="bulk-leads-card">
                    <img src={RecordsFound} alt="Success Records" />
                    <p className="bulk-leads-card-text">Success Records</p>
                    <strong className="bulk-leads-card-value" style={{ color: "#166534" }}>
                        {successRecords}
                    </strong>
                </div>

                <div className="bulk-leads-card">
                    <img src={MissingData} alt="Missing Records" />
                    <p className="bulk-leads-card-text">Missing Records</p>
                    <strong className="bulk-leads-card-value" style={{ color: "#991b1b" }}>
                        {failedRecords}
                    </strong>
                </div>

                <div className="bulk-leads-card">
                    <img src={DuplicateIcon} alt="Duplicate Data" />
                    <p className="bulk-leads-card-text">Duplicate Data</p>
                    <strong className="bulk-leads-card-value" style={{ color: "#b45309" }}>
                        {duplicateRecords}
                    </strong>
                </div>
            </div>

            {/* Download Error Sheet */}
            {excelUrl && (
                <div className="bulk-leads-info" style={{ marginTop: "24px" }}>
                    <div className="bulk-leads-info-left">
                        <img src={MissingData} alt="Error Sheet" />
                        <p>Download Error Sheet</p>
                    </div>
                    <button
                        className="bulkUploadDownload"
                        onClick={handleDownloadErrorSheet}
                    >
                        Download
                    </button>
                </div>
            )}

            {(failedRecords > 0 || duplicateRecords > 0) && !excelUrl && (
                <p style={{
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "13px",
                    color: "#666",
                    fontFamily: "Inter, sans-serif",
                }}>
                    No error sheet available for this upload.
                </p>
            )}

        </div>
    );
};

export default BulkLeadsResult;
